// extracted by mini-css-extract-plugin
export default {"strong":"_3w3LAD8krxBD6k1wLcoxmX","serif":"_3WaxrV0nfrrgs9AN-sWru4"};